import type { LoadResult, Song } from '../types';
import { createInstrument, createPattern } from '../types';
import { isModFile, loadMod } from './mod';
import { isXmFile, loadXm } from './xm';

export { loadMod, isModFile, variantFromMagic } from './mod';
export { loadXm, isXmFile } from './xm';
export { ByteReader, ByteWriter } from './binary';

/** Sniff the format and dispatch. XM is checked first — its signature is exact. */
export function loadModule(buffer: ArrayBuffer): LoadResult {
  if (isXmFile(buffer)) return loadXm(buffer);
  if (isModFile(buffer)) return loadMod(buffer);
  throw new Error('Unrecognised module format — expected a ProTracker MOD or FastTracker II XM.');
}

/** A blank song to open the editor on. */
export function createEmptySong(channels = 8, patternRows = 64): Song {
  const order = new Uint8Array(256);
  const instruments = [];
  for (let i = 0; i < 16; i++) instruments.push(createInstrument(''));
  const defaultPanning = new Uint8Array(channels);
  for (let i = 0; i < channels; i++) {
    // Gentle alternating spread rather than the Amiga's hard pan.
    defaultPanning[i] = (i & 1) === 0 ? 80 : 176;
  }
  return {
    name: 'untitled',
    trackerName: 'FinTracker',
    format: 'xm',
    mode: 'ft2',
    channels,
    order,
    songLength: 1,
    restartPosition: 0,
    patterns: [createPattern(patternRows, channels)],
    instruments,
    initialSpeed: 6,
    initialTempo: 125,
    linearFrequency: true,
    amigaLimits: false,
    defaultPanning,
  };
}
